import { useContext, useEffect } from 'react';
import { UNSAFE_NavigationContext as NavigationContext } from 'react-router-dom';

// react-router-dom's useBlocker only works with a data router (createBrowserRouter +
// RouterProvider), and this app still uses a plain BrowserRouter, so that API throws
// here. Instead, this wraps the navigator's push/replace so in-app navigation (Link
// clicks, navigate() calls) can be intercepted. It does NOT cover the browser's
// back/forward buttons or tab close/refresh - those aren't interceptable this way.
export default function useBlocker(blocker, when = true) {
  const { navigator } = useContext(NavigationContext);

  useEffect(() => {
    if (!when) return undefined;

    const originalPush = navigator.push;
    const originalReplace = navigator.replace;

    navigator.push = (...args) => blocker({ retry: () => originalPush.apply(navigator, args) });
    navigator.replace = (...args) => blocker({ retry: () => originalReplace.apply(navigator, args) });

    return () => {
      navigator.push = originalPush;
      navigator.replace = originalReplace;
    };
  }, [navigator, blocker, when]);
}
